import React from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './bootstrap';

const root = ReactDOM.createRoot(document.getElementById('root'));
// const basename =
//   process.env.NODE_ENV === 'production'
//     ? process.env.REACT_APP_BASNAME_PATH
//     : '/';

root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_BASENAME_PATH}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
